// extracted by mini-css-extract-plugin
module.exports = {"subscribeCoursesContainer":"_34_ZXLeS509DMlP9vwwONA","validation":"_1k4hVhg4s22iVERYTskn7l","textWrapper":"ou5ivVm2zsW1ZOENE4l6g","subscribeEmailWrapper":"xEc31M2j154RICsuLwz6H"};